import * as moment from 'moment';

/* eslint-disable @typescript-eslint/no-explicit-any */
export default {
  // deepCopy Object
  deepCopy<T>(payload: T): T {
    return Object.assign({}, payload);
  },
  // check if an Array is empty
  isEmptyArray(item: any[]): boolean {
    return this.isArray(item) && item.length === 0;
  },

  // Check if anything is an array
  isArray(item: any) {
    return Array.isArray(item);
  },

  isEmptyObject(obj: Object): boolean {
    return typeof obj === 'object' && Object.keys(obj).length === 0;
  },
  isObject(o: any) {
    try {
      return o !== null && typeof o === 'object' && !Array.isArray(o);
    } catch (e) {
      return false;
    }
  },

  // Check if anything is empty (primitive, array, object)
  isEmpty(item: any): boolean {
    return (
      item === '' ||
      Number.isNaN(item) ||
      item === null ||
      item === undefined ||
      this.isEmptyArray(item) ||
      this.isEmptyObject(item)
    );
  },

  // Check if something is string
  isString(value: any): boolean {
    return typeof value === 'string' || value instanceof String;
  },
  // Check if date is empty
  isDateEmpty(date: any): string {
    return !date ? '' : new Date(date).toString();
  },
  // Scroll to position
  scrollTo(x: number, y: number): void {
    window.scroll(x, y);
  },
  // Check if date is in range
  isDateFallsInRange(date: number, startDate: number, endDate: number): boolean {
    return date >= startDate && date <= endDate;
  },
  // Check
  isNumeric(num: any): boolean {
    return !isNaN(num);
  },

  encode(value: string): string {
    return btoa(encodeURIComponent(value));
  },

  decode(value: string): string {
    return atob(decodeURIComponent(value));
  },

  generateUniqueUUID(): string {
    return btoa(`${window.crypto.getRandomValues(new Uint8Array(16)).join('')}`);
  },
  createUppercaseMap(originalMap: any): Map<any, any> {
    const uppercaseMap = new Map();
    for (const key in originalMap) {
      if (Object.hasOwnProperty.call(originalMap, key)) {
        const uppercaseKey = key.toUpperCase();
        uppercaseMap.set(uppercaseKey, originalMap[key]);
      }
    }
    return uppercaseMap;
  },

  objectToMap(obj: object): Map<string, unknown> {
    return new Map(Object.entries(obj));
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  calculateDurationFromCurrentTime(_start_date_time: string) {
    const givenMoment = moment(_start_date_time);
    const currentMoment = moment();
    const difference = givenMoment.diff(currentMoment);

    if (difference < 0) {
      return '00:00:00'; // Return empty if the given time is in the past
    }

    const duration = moment.duration(difference);
    const hours = Math.floor(duration.asHours()); // Get total hours correctly
    const minutes = duration.minutes();
    const seconds = duration.seconds();

    return `${hours}:${minutes}:${seconds}`;
  },

  clickElement(id: string): void {
    const element = document.getElementById(id);
    if (!this.isEmpty(element)) {
      element?.click();
    }
  },

  openLink(url: string, target = '_blank'): void {
    window.open(url, target);
  },
  getRandomColor(): string {
    const NUM_BYTES = 3; // Number of bytes to allocate
    const array = new Uint8Array(NUM_BYTES);
    window.crypto.getRandomValues(array);

    // Convert bytes to hex and join them
    const randomColor = Array.from(array)
      .map(byte => byte.toString(16).padStart(2, '0'))
      .join('');
    if (randomColor === 'fffff') {
      return '#000000';
    }
    return `#${randomColor}`;
  },
  unique(arg: [], key: string): any {
    return arg?.filter(
      (item: any, index: number) => arg.findIndex((o: any) => item[key] === o[key]) === index
    );
  },
  imgErrorHandler(event: Event, fileName: string) {
    const target = event.target as HTMLImageElement;
    const currentSrc = target.src;
    // If current src is a local .svg asset (not already the dummy), try .png before falling back
    if (
      currentSrc.includes('/assets/cardata/') &&
      currentSrc.endsWith('.svg') &&
      !currentSrc.includes('car-dummy')
    ) {
      target.src = currentSrc.replace(/\.svg$/, '.png');
    } else {
      target.src = `assets/cardata/${fileName}`;
    }
  },
};
